import { Stack, Box, Typography } from "@mui/material";
import React from "react";
import { SortableContainer } from "react-sortable-hoc";
import MusicRow from "./musicRow";
import "./index.scss";
import { useTranslation } from "react-i18next";
const PlaylistMusic = SortableContainer(
  ({
    music,
    playListId,
    handleTipClick,
    toggleMenu,
    play,
    createdBy,
    sort,
    playlistNftd,
  }) => {
    const { t } = useTranslation("common");
    return (
      <Box className="__sortable_table">
        <Box className="_sotable_table_row">
          <Typography
            className="_row_head"
            sx={{ width: playlistNftd ? "40% !important" : "30% !important" }}
          >
            {t("nftDetail.music.th1")}
          </Typography>
          <Typography
            className="_row_head"
            sx={{
              //  marginLeft: "20px !important",
              // width: playlistNftd ? "25% !important" : "20% !important",
              textAlign: "center !important",
            }}
          >
            {t("nftDetail.music.th2")}
          </Typography>
          <Typography
            className="_row_head"
            sx={{ width: playlistNftd ? "10% !important" : "" }}
          >
            {t("nftDetail.music.th3")}
          </Typography>
          <Typography
            className="_row_head"
            // sx={{ width: playlistNftd ? "25% !important" : "" }}
          >
            {t("nftDetail.music.th4")}
          </Typography>
        </Box>
        <Box
          className="__sortable_table_body"
          style={{ paddingBottom: playlistNftd ? "100px" : "auto" }}
        >
          {music &&
            music.map((m, index) => (
              <MusicRow
                sort={sort}
                createdBy={createdBy}
                musicLength={music.length - 1}
                play={play}
                key={`item-${index}`}
                index={index}
                musicIndex={index}
                m={m}
                playListId={playListId}
                handleTipClick={handleTipClick}
                toggleMenu={toggleMenu}
                playlistNftd={playlistNftd}
              />
            ))}
        </Box>
      </Box>
    );
  }
);

export default PlaylistMusic;
